import styled, { css } from "styled-components";

import { media } from "constants/media";

export const BackgroundColor = styled.div`
    //stylelint-disable
    background: linear-gradient(
        205deg,
        var(--color-orange-50) 15.84%,
        var(--color-orange-35) 62.59%
    );
    //stylelint-enable
    width: 100%;
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 40px 0;
    position: relative;
    width: 100%;

    ${media.mdUp} {
        align-items: center;
        flex-direction: row;
        gap: 48px;
    }

    ${media.lgUp} {
        padding: 80px;
    }
`;

export const VideoWrapper = styled.div<{ roundedCorners?: boolean }>`
    aspect-ratio: 16 / 9;
    border-radius: 300px;
    margin: 24px 0;

    /* stylelint-disable order/properties-alphabetical-order */ /* stylelint-disable order/order */
    ${({ roundedCorners }) =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        roundedCorners &&
        css`
            * {
                border-radius: 300px;

                ::after {
                    border-radius: 300px;
                }
            }
            background: transparent;
            margin: 24px 0;
            padding: 0 24px;
            width: 100%;
        `} /* stylelint-enable order/properties-alphabetical-order */ /* stylelint-enable order/order */


    video {
        object-fit: cover;
    }

    ${media.xlUp} {
        min-width: 680px;
    }
`;

export const TextSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 472px;
`;

export const Title = styled.h2``;

export const Description = styled.p``;
